var $ = require( 'jquery' );
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import gsap from "gsap";
import {Linear} from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";


ScrollMagicPluginGsap(ScrollMagic, gsap);




$(document).ready(function() {
   initParallax();

});

function initParallax() {
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

    $(".section-hero-smaller__bg").each(function() {

        new ScrollMagic.Scene({triggerElement: '.section-hero-smaller__top'})
            .setTween('.section-hero-smaller .section-hero-smaller__bg', {y: "100%", ease: Linear.easeNone})

            .addTo(controller);
    });

}